<template>
  <div v-if="dataWasDownloadedSuccessfully">
    <div class="text-xs-left mb-5" v-for="(item, index) in data" :key="index">

      <h2>{{ item.pressTitle }}</h2>

      <div class="mb-3">{{ item.pressDescription }}</div>

      <a :href="'mailto:'+item.contactEmail.fields.mailto" class="btn btn-text wdth-80 font-md"
        :title="item.contactEmail.fields.seoTitle">
        <i class="icon-arrow-right"></i> {{ item.contactEmail.fields.title }}
      </a>
    </div>
    <button-download-app :button-download-links="buttonDownloadLinks" />
  </div>
</template>

<script>
  import buttonDownloadApp from './buttonDownloadApp'
  import { getContent } from '@/javascripts/contentful';
  import _ from 'lodash'

  export default {
    name: 'speakerAndPressApp',
    components: {
      buttonDownloadApp
    },
    props: ["speakerAndPress"],
    data() {
      return {
        data: [],
        dataWasDownloadedSuccessfully: false,
        buttonDownloadLinks: null,
      }
    },
    mounted() {
      _.each(this.speakerAndPress, async (obj) => {
        const { fields } = await getContent(obj.sys.id)

        if (fields) {
          this.data.push(fields);

          if (fields.downloadPackages)
            this.buttonDownloadLinks = { ...fields.downloadPackages }

          this.dataWasDownloadedSuccessfully = true
        }
      })
    },
  }
</script>
